import { Checkbox } from '@material-ui/core';
import React from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const confirmarCheckboxAlert = async ({ opcoes = {}, confirmar = () => {}, titulo = '', mensagem = '' }) => {
  const MySwal = withReactContent(Swal);
  let checkLocal = opcoes.checked;

  const result = await MySwal.fire({
    reverseButtons: true,
    title: titulo,
    text: mensagem,
    icon: 'warning',
    showCancelButton: true,
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    html: (
      <>
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Checkbox
            color="primary"
            onChange={() => {
              checkLocal = !checkLocal;
              opcoes.setChecked(checkLocal);
            }}
            name="checkedA"
          />
          Não exibir esta mensagem novamente
        </span>
      </>
    ),
  });

  if (result.value) {
    confirmar();
  }
};

export default confirmarCheckboxAlert;
